  const tabsespdabout = document.querySelectorAll('.tabs__btnpdabout');
    const tabsContent = document.querySelectorAll('.tabs__bodypdabout');

    if (tabsContent.length > 0 || tabs.length > 0) {

        function hideTabContent() {
            tabsContent.forEach(item => {
                item.classList.remove('active');
            });

            tabsespdabout.forEach(item => {
                item.classList.remove('active');
            });
        }

        function showTabContent(i = 0) {
            tabsContent[i].classList.add('active');
            tabsespdabout[i].classList.add('active');
        }

        hideTabContent();
        showTabContent();

        tabsespdabout.forEach((tab, index) => {
            tab.addEventListener('click', () => {
                hideTabContent();
                showTabContent(index);
            });
        });
    }